import React from 'react';
import { Link } from 'react-router-dom';
// import { createPageUrl } from '@/utils';
import Icon from '../ui/Icon';

const statusConfig = {
  active: { label: 'Active', className: 'badge-solid-emerald' },
  pending: { label: 'Pending', className: 'badge-solid-amber' },
  sold: { label: 'Sold', className: 'badge-solid-blue' },
  withdrawn: { label: 'Withdrawn', className: 'badge-solid-slate' }
};

const propertyTypeLabels = {
  single_family: 'Single Family',
  condo: 'Condo',
  townhouse: 'Townhouse',
  multi_family: 'Multi Family',
  land: 'Land',
  commercial: 'Commercial'
};

export default function ListingCard({ listing, onEdit }) {
  const status = statusConfig[listing.status] || statusConfig.active;
  const mainPhoto = listing.photos?.[0] || 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop';

  return (
    <div className="card" style={{ overflow: 'hidden' }}>
      <div style={{ position: 'relative', height: '13rem', overflow: 'hidden' }}>
        <img 
          src={mainPhoto} 
          alt={listing.title}
          style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }}
        />
        <div style={{ position: 'absolute', top: '0.75rem', left: '0.75rem', display: 'flex', gap: '0.5rem' }}>
          <span className={`badge ${status.className}`}>{status.label}</span>
        </div>
        <div style={{ position: 'absolute', top: '0.75rem', right: '0.75rem' }}>
          <span className="badge badge-white">
            {propertyTypeLabels[listing.property_type] || listing.property_type}
          </span>
        </div>
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)'
        }} />
        <div style={{ position: 'absolute', bottom: '0.75rem', left: '0.75rem', right: '0.75rem' }}>
          <p style={{ fontSize: '1.5rem', fontWeight: 700, color: 'white' }}>
            ${listing.list_price?.toLocaleString()}
          </p>
        </div>
      </div>
      
      <div className="p-5" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div>
          <h3 className="font-semibold text-slate-900 text-lg line-clamp-1">
            {listing.title}
          </h3>
          <p className="text-sm text-slate-500 flex items-center gap-1 mt-1">
            <Icon name="mapPin" size={14} />
            {listing.city}, {listing.state}
          </p>
        </div>
        
        <div className="flex items-center gap-4 text-sm text-slate-600">
          {listing.bedrooms && (
            <span className="flex items-center gap-1">
              <Icon name="bed" size={16} />
              {listing.bedrooms} bd
            </span>
          )}
          {listing.bathrooms && (
            <span className="flex items-center gap-1">
              <Icon name="bath" size={16} />
              {listing.bathrooms} ba
            </span>
          )}
          {listing.square_feet && (
            <span className="flex items-center gap-1">
              <Icon name="square" size={16} />
              {listing.square_feet.toLocaleString()} sqft
            </span>
          )}
        </div>
        
        <div className="flex gap-2" style={{ paddingTop: '0.5rem' }}>
          <Link to={`/listing-details/${listing.id}`} style={{ flex: 1, textDecoration: 'none' }}>
            <button className="btn btn-outline w-full" style={{ fontSize: '0.875rem' }}>
              <Icon name="eye" size={16} />
              View
            </button>
          </Link>
          <button className="btn btn-outline btn-icon" onClick={() => onEdit?.(listing)}>
            <Icon name="edit" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}